import { themeFolderPath } from '../../../App';
import React, { Component, type JSX } from 'react';
import { cart } from '../../Cart/Cart';
import { price } from '../../../util/price.function';

interface AddOnProps {
  id: string;
  idTraining: string;
  title: string;
  subject: string;
  level: string;
  price: string;
  tooltip?: string;
  inCart: boolean;
}

interface AddOnState {
  deleting: boolean;
  adding: boolean;
}

/**
 * Sub item in the cart, the inCart flag, determines
 * whether the sub-item is displayed as an upsell article
 * or as sub-item article.
 *
 * The course and level of an addon are extracted from
 * the parent training.
 */
export class AddOnItem extends Component<AddOnProps, AddOnState>{

  public state: AddOnState = {
    deleting: false,
    adding: false,
  };

  /**
   * Remove the addOn from the php session. Show a loading
   * icon while deleting.
   */
  private onRemoveAddOn(): void {
    const { id, idTraining } = this.props;
    this.setState({ deleting: true });
    cart.removeArticle(idTraining, id);
  }

  /**
   * Add the addOn to the php session. Show a loading
   * icon while adding.
   */
  private onAddAddOn(): void {
    const { id, idTraining } = this.props;
    this.setState({ adding: true });
    cart.addArticle(idTraining, id);
  }

  /**
   * Render the addOn, the item has 2 possible state, "in the cart" or
   * "not yet added to the cart". The item is rendered accordingly.
   */
  public render(): JSX.Element {
    const state = this.state;
    const props = this.props;

    return (
      <li className={`checkout-list__product checkout-list__sub-item${!props.inCart ? ' not-in-cart' : ''}`}>

        { props.inCart && <div className="checkout-list__product-remove float-right">
          { state.deleting
            ? (<i className="fa fa-circle-o-notch fa-spin"/>)
            : (<img onClick={(): void => this.onRemoveAddOn()}
              src={ `${themeFolderPath}/images/checkout__cross.svg` }
              alt={'remove from cart'}/>)
          }
        </div>}

        <div className="checkout-list__cell--left">
          <div className="checkout-list__product-title">
            {props.title} | {props.subject} - {props.level}

            {props.tooltip
            && <i className="checkout-list__info-icon fa fa-info-circle">
              <span className="checkout-list__tooltip js-tooltip"
                dangerouslySetInnerHTML={{ __html: props.tooltip }}/>
            </i>}
          </div>
          {!props.inCart && <div>&euro; { price(props.price) }</div>}
        </div>
        <div className="checkout-list__cell--right">
          {props.inCart
            ? (
              <div className="checkout-list__product-price">
                &euro; { price(props.price) }
              </div>
            )
            : (
              <a className="btn btn-primary checkout-list__book-btn"
                onClick={(): void => this.onAddAddOn()}>
                <i className={ state.adding ? 'fa fa-spinner fa-spin' : 'fa fa-plus' }/>
              </a>
            )
          }
        </div>
      </li>
    );
  }
}
